import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PolicyAppState } from '../types';
import { PoliciesReduxActions } from '../actions';
import { NavigationHeaderSlice, PolicyContext } from './types.navigation';

// SELECTORS
export const getNavigationHeaderSlice = (state: PolicyAppState): NavigationHeaderSlice => state.navigationHeaderSlice;

// ACTIONS
export const setPolicyName = createAction<string>(PoliciesReduxActions.SET_POLICY_NAME);
export const setPolicyNameActionHandler = (state: PolicyAppState, action: PayloadAction<string>): void => {
  state.navigationHeaderSlice.policyName = action.payload;
  state.navigationHeaderSlice.updateNeeded = true;
};

export const setNavigationHeaderSlice = createAction<{ policyName: string; context: PolicyContext }>(
  PoliciesReduxActions.SET_NAVIGATION_HEADER_SLICE
);
export const setNavigationHeaderSliceActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<{ policyName: string; context: PolicyContext }>
): void => {
  state.navigationHeaderSlice = {
    policyName: action.payload.policyName,
    context: action.payload.context,
    updateNeeded: true,
  };
};
